import React, { useState } from 'react'
import PropTypes from 'prop-types'

import DownloadIcon from '@mui/icons-material/Download'

import axios from '../../dataClient/dataClient'
import { handleDownloadResponse } from '../../util/downloadFile'
import { SecondaryButton } from '../common/Button'
import { ErrorMessage } from '../common/UserMessage'
import { FlexEndButtonErrorContainer } from '../styles/Containers'

function DownloadCommunicationButton({ id, name }) {
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [downloadError, setDownloadError] = useState(false)

  function handleDownloadClick(event) {
    event.stopPropagation()

    setDownloadError(false)
    setDownloadLoading(true)
    const fileName = `${name}.pdf`

    axios
      .get(`/communication/${id}/download`, { responseType: 'blob' })
      .then(response => handleDownloadResponse(response, fileName, 'download'))
      .catch(e => {
        setDownloadError(true)
        console.error('an error occurred while downloading the communication', name, e)
      })
      .finally(() => {
        setDownloadLoading(false)
      })
  }

  return (
    <FlexEndButtonErrorContainer gap="5px">
      <SecondaryButton onClick={handleDownloadClick} loading={downloadLoading}>
        <DownloadIcon />
        Download
      </SecondaryButton>
      {downloadError && <ErrorMessage>Error downloading communication. Please try again.</ErrorMessage>}
    </FlexEndButtonErrorContainer>
  )
}

DownloadCommunicationButton.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

export default DownloadCommunicationButton
